// pt-PT source of truth for the admin area (Permissões, Active Directory,
// Viaturas and the module placeholder). English mirrors this in ../en/admin.ts.
export const admin = {
  permissions: {
    title: 'Permissões',
    subtitle: 'Acesso a módulos e dados reservados',
    adminOnly: 'Reservado a administradores do portal.',
    tabs: {
      modules: 'Acesso a módulos',
      reserved: 'Dados reservados',
    },
    subject: {
      role: 'Papel',
      user: 'Utilizador',
      group: 'Grupo',
    },
    permission: {
      viewReserved: 'Ver dados reservados',
    },
    role: {
      onboarding: 'Onboarding',
      hr: 'RH',
      researcher: 'Investigador',
      direction: 'Direção',
      admin: 'Admin',
    },
    change: 'Alterar',
    remove: 'Remover',
    modulesPanel: {
      introPart1:
        'Associe um colaborador que já exista no portal a um ou mais módulos e defina se pode apenas ',
      introView: 'consultar',
      introPart2: ' ou também ',
      introEdit: 'editar',
      introPart3: '. O acesso é ligado no login pelo campo ',
      introUserName: 'User Name',
      introPart4: ' da ficha. Os administradores veem todos os módulos.',
      newTitle: 'Nova atribuição',
      collaborator: 'Colaborador',
      collaboratorPlaceholder: 'Procurar por nome, código ou email…',
      module: 'Módulo',
      level: 'Nível',
      levelView: 'Consultar',
      levelEdit: 'Editar',
      submitBusy: 'A atribuir…',
      submit: 'Atribuir acesso',
      grantsTitle: 'Atribuições',
      filterPlaceholder: 'Filtrar por colaborador…',
      allModules: 'Todos os módulos',
      emptyNone: 'Sem atribuições. Todos veem apenas o seu perfil; os administradores veem tudo.',
      emptyFiltered: 'Nenhuma atribuição corresponde ao filtro.',
      colCollaborator: 'Colaborador',
      colUserName: 'User Name',
      colModule: 'Módulo',
      colLevel: 'Nível',
      noMatch: '— (sem match)',
    },
    reserved: {
      introPart1:
        'Afine quem pode ver dados reservados, por papel, utilizador ou grupo. Uma regra de',
      introDeny: ' negar',
      introPart2: ' prevalece sempre sobre uma de permitir. Os administradores veem tudo.',
      newTitle: 'Nova regra',
      subject: 'Sujeito',
      subjectRole: 'Papel',
      subjectUser: 'Utilizador',
      subjectGroup: 'Grupo (id/nome)',
      subjectUserPlaceholder: 'username',
      subjectGroupPlaceholder: 'group-id',
      permission: 'Permissão',
      effect: 'Efeito',
      effectAllow: 'Permitir',
      effectDeny: 'Negar',
      submitBusy: 'A adicionar…',
      submit: 'Adicionar regra',
      rulesTitle: 'Regras',
      empty: 'Sem regras (aplicam-se apenas os valores por omissão).',
      colSubject: 'Sujeito',
      colIdentifier: 'Identificador',
      colPermission: 'Permissão',
      colEffect: 'Efeito',
    },
  },
  ad: {
    title: 'Active Directory',
    subtitle: 'Criação de contas na AD — OU, username e mapa de atributos',
    adminOnly: 'Reservado a administradores do portal.',
    intro:
      'Configura como as contas são criadas na AD: OU de destino, regras de username e o mapa campo da ficha → atributo AD. A ligação (LDAPS) fica em variáveis de ambiente.',
    saved: 'Guardado.',
    statusTitle: 'Estado',
    mode: 'Modo',
    configured: 'Configurado',
    url: 'URL',
    yes: 'Sim',
    no: 'Não',
    settingsTitle: 'Definições',
    defaultOu: 'OU de destino (DN)',
    upnSuffix: 'Sufixo UPN',
    patternsLabel: 'Regras de username (uma por linha; tokens: {f} {l} {first} {last})',
    saveBusy: 'A guardar…',
    save: 'Guardar definições',
    mappingTitle: 'Mapa campo → atributo AD',
    fieldKeyPlaceholder: 'Campo da ficha (ex.: departamento)',
    adAttributePlaceholder: 'Atributo AD (ex.: department)',
    add: 'Adicionar',
    noMappings: 'Sem mapeamentos.',
    colFieldKey: 'Campo da ficha',
    colAdAttribute: 'Atributo AD',
    remove: 'Remover',
    test: {
      title: 'Testar sugestão de username',
      firstName: 'Primeiro nome',
      lastName: 'Apelido',
      submit: 'Sugerir',
      resultLabel: 'Sugestão: ',
      noResult: 'Nenhuma regra produziu um username disponível.',
    },
  },
  vehicles: {
    title: 'Viaturas',
    countOne: '{n} registo',
    countMany: '{n} registos',
    create: 'Novo registo',
    searchPlaceholder: 'Pesquisar por matrícula, colaborador, local, cartão…',
    search: 'Pesquisar',
    empty: 'Sem registos de viaturas.',
    colCollaborator: 'Colaborador',
    colPlate: 'Matrícula',
    colVehicle: 'Viatura',
    colZone: 'Zona',
    colLocation: 'Local',
    colCards: 'Cartões',
    colStatus: 'Estado',
    active: 'Ativo',
    inactive: 'Inativo',
    edit: 'Editar',
    delete: 'Eliminar',
    confirmDelete: 'Eliminar o registo da viatura {plate}?',
    zone: {
      internal: 'Interno',
      external: 'Externo',
    },
    form: {
      editTitle: 'Editar registo',
      createTitle: 'Novo registo de viatura',
      collaborator: 'Colaborador *',
      collaboratorPlaceholder: 'Procurar colaborador por nome, código ou email…',
      change: 'Alterar',
      plate: 'Matrícula *',
      vehicle: 'Viatura (marca/modelo)',
      zoneLabel: 'Zona *',
      location: 'Local *',
      locationSelect: 'Selecionar…',
      locationPlaceholder: 'Defina os locais em Definições → Configuração Global',
      cards: 'Cartões físicos (ids separados por vírgula)',
      cardsPlaceholder: 'ex.: 00123, 00124',
      notes: 'Notas',
      active: 'Ativo',
      cancel: 'Cancelar',
      saveBusy: 'A guardar…',
      save: 'Guardar',
    },
  },
  placeholder: {
    inPreparation: 'Módulo em preparação. As funcionalidades serão adicionadas em breve.',
  },
};
